import { Controller } from "react-hook-form";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { SpanError } from "./SpanError";

const animatedComponents = makeAnimated();
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "white",
    borderColor: state.isFocused ? "#3b82f6" : "#e5e7eb", // cambia esto a #e5e7eb cuando no está enfocado
    boxShadow: state.isFocused ? "0 0 0 1px #93c5fd" : "none",
    "&:hover": {
      borderColor: "#3b82f6", // esto hace que el borde se vuelva azul cuando se desplaza el mouse
    },
    padding: "6px 1rem",
    borderRadius: "0.50rem",
    fontWeight: "400",
    borderWidth: "1px", // grosor del borde
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#3b82f6"
      : state.isFocused
        ? "#93c5fd"
        : "white",
    color: state.isSelected ? "white" : "black",
    padding: "0.25rem 1rem",
    "&:hover": {
      backgroundColor: "#93c5fd",
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#93c5fd",
    borderRadius: "0.5rem",
    // padding: "0.25rem 0.5rem",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#1e3a8a",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#1e3a8a",
    "&:hover": {
      backgroundColor: "#1e3a8a",
      color: "white",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
  singleValue: (provided) => ({
    ...provided,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
};

export const FormSelect = ({
  name,
  label,
  control,
  options,
  isMulti = false,
  validation = {},
  // maxMenuHeight = 400,
  defaultValue = [],
  placeholder = "Select...",
  handleChange,
  error,
  className = "",
  classNameError = "-bottom-4",
}) => (

  <div className={className}>
    <label className="tracking-wide text-slate-700 font-bold uppercase text-sm" htmlFor={name}>
      {label} {validation.required && <span className="absolute text-base text-red-500 font-bold -top-1">*</span>}
    </label>
    <Controller
      name={name}
      control={control}
      //defaultValue={defaultValue}
      rules={validation}
      render={({ field }) => (
        <Select
          isMulti={isMulti}
          closeMenuOnSelect={!isMulti}
          //maxMenuHeight={maxMenuHeight}
          components={animatedComponents}
          styles={customStyles}
          options={options}
          placeholder={placeholder}
          menuPlacement="auto"
          {...field}
          onChange={(selected) => {
            field.onChange(selected);
            if (handleChange) handleChange(selected);
          }}
          className={`w-full text-black shadow-sm rounded-lg input-field focus:ring-1  focus:border-blue-500 focus:ring-blue-300 ${error ? "border-red-400" : " border-slate-300"
            }`}
        />
      )}
    />
    {error && <SpanError error={error} className={classNameError} />}
  </div>
);
